export default __webpack_public_path__ + "static/media/ic_call.f0b3cc2c.svg";